"use strict";

export const dialog = {
    namespaced: true,
    state: {
        blogPostDialog: false,
    },
    getters: {
        getBlogPostDialog: state => state.blogPostDialog,
    },
    mutations: {
        TOGGLE_BLOG_POST_DIALOG: (state) => { state.blogPostDialog = !state.blogPostDialog },
    },
    actions: {},
}